import React from 'react';
import { InstagramIcon, FacebookIcon } from 'lucide-react';
const footerLinks = [{
  label: 'About',
  href: '#about'
}, {
  label: 'Services',
  href: '#services'
}, {
  label: 'Experience',
  href: '#experience'
}, {
  label: 'Location',
  href: '#location'
}];
export function Footer() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <footer className="w-full bg-bark text-cream/90 py-16 md:py-20 px-6 lg:px-8" data-id="element-120">
      <div className="max-w-6xl mx-auto" data-id="element-121">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 items-start mb-16" data-id="element-122">
          {/* Brand */}
          <div data-id="element-123">
            <p className="font-heading text-2xl font-semibold tracking-[0.2em] text-cream mb-2" data-id="element-124">
              ZEN BARN SPA
            </p>
            <p className="font-body text-sm text-cream/50" data-id="element-125">
              Richiș, Transylvania
            </p>
          </div>

          {/* Quick links */}
          <nav aria-label="Footer navigation" data-id="element-126">
            <p className="font-body text-sm font-medium tracking-wide uppercase text-cream/40 mb-4" data-id="element-127">
              Explore
            </p>
            <ul className="space-y-3" data-id="element-128">
              {footerLinks.map(link => <li key={link.label} data-id="element-129">
                  <a href={link.href} onClick={e => handleClick(e, link.href)} className="font-body text-cream/70 hover:text-terracotta transition-colors duration-300" data-id="element-130">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </nav>

          {/* Social & contact */}
          <div data-id="element-131">
            <p className="font-body text-sm font-medium tracking-wide uppercase text-cream/40 mb-4" data-id="element-132">
              Connect
            </p>
            <div className="flex gap-4 mb-6" data-id="element-133">
              <a href="https://wa.me/40771047817" target="_blank" rel="noopener noreferrer" aria-label="Message us on WhatsApp" className="w-10 h-10 rounded-full bg-cream/10 flex items-center justify-center hover:bg-terracotta/30 transition-colors duration-300" data-id="element-134">
                <svg className="w-5 h-5 text-cream/70" viewBox="0 0 24 24" fill="currentColor" data-id="element-135">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" data-id="element-136" />
                </svg>
              </a>
              <a href="https://www.instagram.com/zenbarnspa/" target="_blank" rel="noopener noreferrer" aria-label="Follow us on Instagram" className="w-10 h-10 rounded-full bg-cream/10 flex items-center justify-center hover:bg-terracotta/30 transition-colors duration-300" data-id="element-137">
                <InstagramIcon className="w-5 h-5 text-cream/70" data-id="element-138" />
              </a>
              <a href="https://www.facebook.com/p/Zen-Barn-Spa-100064837326764/" target="_blank" rel="noopener noreferrer" aria-label="Follow us on Facebook" className="w-10 h-10 rounded-full bg-cream/10 flex items-center justify-center hover:bg-terracotta/30 transition-colors duration-300" data-id="element-139">
                <FacebookIcon className="w-5 h-5 text-cream/70" data-id="element-140" />
              </a>
            </div>
            <a href="mailto:hello@zenbarnspa.com" className="font-body text-sm text-cream/50 hover:text-terracotta transition-colors" data-id="element-141">
              hello@zenbarnspa.com
            </a>
          </div>
        </div>

        {/* Divider & copyright */}
        <div className="border-t border-cream/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-142">
          <p className="font-body text-sm text-cream/30" data-id="element-143">
            © 2026 Zen Barn Spa. All rights reserved.
          </p>
          <p className="font-body text-xs text-cream/20" data-id="element-144">
            Crafted with care in Transylvania
          </p>
        </div>
      </div>
    </footer>;
}